<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { AppTable, AppTd, AppTh, AppTr } from '@shared/ui/tables'
import { ModalDefault } from '@shared/ui/modals'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import TutorBillingModalHeader from '../TutorBillingModalHeader.vue'
import { TUTOR_BILLING_EXPORT_PREVIEW_ROWS } from '../../config/tutor-billing'
import { useModalTutorBillingExport } from '../../model/modal-tutor-billing-export.hook'

defineOptions({
  name: 'ModalTutorBillingExport',
})

const {
  isOpen,
  isSaving,
  title,
  subtitle,
  hasType,
  columns,
  setClose,
  setSend,
} = useModalTutorBillingExport()
</script>

<template>
  <ModalDefault
    :show="isOpen"
    :loading="isSaving"
    class-name="modal-tutor-billing-export"
    is-close-button
    @click:overlay="setClose"
    @click:close="setClose"
  >
    <TutorBillingModalHeader
      :title="title"
      :subtitle="subtitle"
    />

    <AppTable
      class="rounded-table modal-tutor-billing-export__table"
      :paginated="false"
    >
      <template #head>
        <AppTr>
          <AppTh
            v-for="column in columns"
            :key="column"
          >
            <AppText
              name="body1-medium"
              color="slate-900"
              class="modal-tutor-billing-export__head"
            >
              {{ column }}
            </AppText>
          </AppTh>
        </AppTr>
      </template>

      <template #body>
        <AppTr
          v-for="row in TUTOR_BILLING_EXPORT_PREVIEW_ROWS"
          :key="row"
          aria-hidden="true"
        >
          <AppTd
            v-for="column in columns"
            :key="column"
            class="medium"
          >
            <span class="modal-tutor-billing-export__placeholder" />
          </AppTd>
        </AppTr>
      </template>
    </AppTable>

    <template #controls>
      <BtnPrimary
        text="Send .csv to my email"
        :disabled="!hasType || isSaving"
        @click="setSend"
      />
      <BtnSecondary
        text="Cancel"
        :disabled="isSaving"
        @click="setClose"
      />
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalTutorBillingExport.scss" />
